<!-- TEMPLATE -->
<template>
    <v-layout wrap justify-center align-center>
        <v-flex xs12>
            <v-data-table :headers="headers" :items="enrichedStats" class="elevation-1">
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs-right">{{ props.item.kills }}</td>
                    <td class="text-xs-right">{{ props.item.deaths }}</td>
                    <td class="text-xs-right">{{ props.item.assists }}</td>
                    <td class="text-xs-right">{{ props.item.minutesPlayed }}</td>
                    <td class="text-xs-right">{{ props.item.goldsPerMinute }}</td>
                    <td class="text-xs-right">{{ props.item.damagePerMinute }}</td>
                    <td class="text-xs-right">{{ props.item.wardPlacedPerMinute }}</td>
                    <td class="text-xs-right">{{ props.item.wardKilledPerMinute }}</td>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>
<!-- SCRIPT -->
<script>
import _ from 'lodash'

export default {
    name: 'Drafts',
    props: {
        players: Array,
        title: String
    },
    data: function() {
        return {
            headers: [
                { text: 'Players Name', value: 'name' },
                { text: 'Kills', value: 'kills' },
                { text: 'Deaths', value: 'deaths' },
                { text: 'Assists', value: 'assists' },
                { text: 'Minutes played', value: 'minutesPlayed' },
                { text: 'Gold per minute', value: 'goldsPerMinute' },
                { text: 'Damage per minute', value: 'damagePerMinute' },
                { text: 'Wards placed per minute', value: 'wardPlacedPerMinute' },
                { text: 'Ward killed per minute', value: 'wardKilledPerMinute' },
            ]
        }
    },
    methods: {

    },
    computed: {
        enrichedStats: function() {
            return _.map(this.players, p => {
                let minutesPlayed = Math.round(p.timePlayed / 60);

                return {
                    name: p.name,
                    kills: p.kills,
                    deaths: p.deaths,
                    assists: p.assists,
                    minutesPlayed: minutesPlayed,
                    goldsPerMinute: Math.round(p.goldEarned / minutesPlayed),
                    damagePerMinute: Math.round(p.totalDamageDealtToChampions / minutesPlayed),
                    wardPlacedPerMinute: Math.round((p.wardsPlaced / minutesPlayed) * 100) / 100,
                    wardKilledPerMinute: Math.round((p.wardsKilled / minutesPlayed) * 100) / 100
                }
            })
        }
    }
}
</script>
<!-- STYLE -->
<style scoped>
</style>